export default {
  props: {
    seoTitle: {
      type: String,
      required: false,
      default: null,
    },

    seoDescription: {
      type: String,
      required: false,
      default: null,
    },

    seoKeywords: {
      type: String,
      required: false,
      default: null,
    },

    jsonLd: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data () {
    return {
      initialPage: this.data?.meta?.pagination?.current_page || 1,
      currentPage: this.data?.meta?.pagination?.current_page || 1,
      totalPages: this.data?.meta?.pagination?.total_pages || 1,
      currentFilter: this.filters,
    };
  },
};
